
(() => {
  if (customElements.get('product-image-zoom')) return;

  const state = {
    root: null,
    image: null,
    counter: null,
    previousButton: null,
    nextButton: null,
    items: [],
    index: 0,
    isOpen: false,
    previousFocus: null,
    bodyOverflow: '',
    htmlOverflow: '',
    touchStartX: 0,
    touchStartY: 0,
    lastSwipeAt: 0
  };

  function createLightbox() {
    if (state.root) return;

    const style = document.createElement('style');
    style.id = 'rl-product-lightbox-styles';

    style.textContent = `
      #rl-product-lightbox {
        position: fixed;
        inset: 0;
        z-index: 2147483647;
        display: none;
        background: rgba(0, 0, 0, 0.94);
        color: #fff;
        font-family: inherit;
      }

      #rl-product-lightbox.is-open {
        display: block;
      }

      #rl-product-lightbox .rl-lightbox__stage {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 65px 80px;
        box-sizing: border-box;
        cursor: zoom-out;
      }

      #rl-product-lightbox .rl-lightbox__image {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 2px;
        cursor: default;
        user-select: none;
        -webkit-user-drag: none;
      }

      #rl-product-lightbox .rl-lightbox__close {
        position: absolute;
        top: 20px;
        right: 24px;
        z-index: 3;
        width: 44px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.12);
        border: 0;
        border-radius: 50%;
        color: #fff;
        font-family: inherit;
        font-size: 28px;
        font-weight: 300;
        line-height: 1;
        cursor: pointer;
        transition: background 0.2s;
      }

      #rl-product-lightbox .rl-lightbox__close:hover {
        background: rgba(255, 255, 255, 0.25);
      }

      #rl-product-lightbox .rl-lightbox__nav {
        position: absolute;
        top: 50%;
        z-index: 3;
        transform: translateY(-50%);
        width: 46px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.12);
        border: 0;
        border-radius: 50%;
        color: #fff;
        font-family: inherit;
        font-size: 34px;
        font-weight: 300;
        line-height: 1;
        cursor: pointer;
        transition: background 0.2s;
      }

      #rl-product-lightbox .rl-lightbox__nav:hover {
        background: rgba(255, 255, 255, 0.25);
      }

      #rl-product-lightbox .rl-lightbox__nav--prev {
        left: 20px;
      }

      #rl-product-lightbox .rl-lightbox__nav--next {
        right: 20px;
      }

      #rl-product-lightbox .rl-lightbox__nav[hidden] {
        display: none;
      }

      #rl-product-lightbox .rl-lightbox__counter {
        position: absolute;
        bottom: 22px;
        left: 50%;
        z-index: 3;
        transform: translateX(-50%);
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(255, 255, 255, 0.8);
        pointer-events: none;
      }

      #rl-product-lightbox button:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 3px;
      }

      @media (max-width: 767px) {
        #rl-product-lightbox .rl-lightbox__stage {
          padding: 65px 12px 85px;
        }

        #rl-product-lightbox .rl-lightbox__close {
          top: 14px;
          right: 14px;
          width: 40px;
          height: 40px;
        }

        #rl-product-lightbox .rl-lightbox__nav {
          top: auto;
          bottom: 13px;
          transform: none;
          width: 42px;
          height: 42px;
        }

        #rl-product-lightbox .rl-lightbox__nav--prev {
          left: 18px;
        }

        #rl-product-lightbox .rl-lightbox__nav--next {
          right: 18px;
        }

        #rl-product-lightbox .rl-lightbox__counter {
          bottom: 27px;
        }
      }
    `;

    document.head.appendChild(style);

    const root = document.createElement('div');

    root.id = 'rl-product-lightbox';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product image gallery');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('tabindex', '-1');

    root.innerHTML = `
      <div class="rl-lightbox__stage">
        <img
          class="rl-lightbox__image"
          alt="Product image"
          draggable="false"
        >
      </div>

      <button
        type="button"
        class="rl-lightbox__close"
        data-rl-action="close"
        aria-label="Close gallery"
      >×</button>

      <button
        type="button"
        class="rl-lightbox__nav rl-lightbox__nav--prev"
        data-rl-action="previous"
        aria-label="Previous image"
      >‹</button>

      <button
        type="button"
        class="rl-lightbox__nav rl-lightbox__nav--next"
        data-rl-action="next"
        aria-label="Next image"
      >›</button>

      <div
        class="rl-lightbox__counter"
        aria-live="polite"
      ></div>
    `;

    document.body.appendChild(root);

    state.root = root;
    state.image = root.querySelector('.rl-lightbox__image');
    state.counter = root.querySelector('.rl-lightbox__counter');
    state.previousButton = root.querySelector(
      '[data-rl-action="previous"]'
    );
    state.nextButton = root.querySelector(
      '[data-rl-action="next"]'
    );

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rl-action]');

      if (button) {
        const action = button.getAttribute('data-rl-action');

        if (action === 'close') {
          closeLightbox();
        }

        if (action === 'previous') {
          changeImage(-1);
        }

        if (action === 'next') {
          changeImage(1);
        }

        return;
      }

      const clickedBackground =
        event.target === root ||
        event.target.classList.contains('rl-lightbox__stage');

      if (
        clickedBackground &&
        Date.now() - state.lastSwipeAt > 400
      ) {
        closeLightbox();
      }
    });

    root.addEventListener('touchstart', (event) => {
      if (!state.isOpen || !event.touches.length) return;

      state.touchStartX = event.touches[0].clientX;
      state.touchStartY = event.touches[0].clientY;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (!state.isOpen || !event.changedTouches.length) return;

      const deltaX =
        event.changedTouches[0].clientX - state.touchStartX;

      const deltaY =
        event.changedTouches[0].clientY - state.touchStartY;

      if (
        Math.abs(deltaX) > 50 &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        state.lastSwipeAt = Date.now();
        changeImage(deltaX < 0 ? 1 : -1);
      }
    }, { passive: true });

    document.addEventListener('keydown', handleKeyboard);
  }

  function getGalleryImages(trigger) {
    const gallery =
      trigger.closest('.product-gallery') ||
      trigger.closest('[data-js-product-gallery]') ||
      trigger.closest('product-page') ||
      trigger.closest('.shopify-section') ||
      document;

    const elements = gallery.querySelectorAll(
      'product-image-zoom[data-image]'
    );

    const images = [];
    const usedIds = new Set();

    elements.forEach((element) => {
      const src = element.getAttribute('data-image');
      if (!src) return;

      const mediaWrapper = element.closest(
        '.product-gallery-item'
      );

      const mediaId = mediaWrapper
        ? mediaWrapper.getAttribute('data-media-id')
        : null;

      const uniqueId = mediaId || src;

      if (usedIds.has(uniqueId)) return;

      usedIds.add(uniqueId);

      const imageElement = mediaWrapper
        ? mediaWrapper.querySelector('img')
        : null;

      images.push({
        element: element,
        src: src,
        id: uniqueId,
        alt: imageElement
          ? imageElement.getAttribute('alt') || 'Product image'
          : 'Product image'
      });
    });

    return images;
  }

  function openLightbox(trigger) {
    createLightbox();

    state.items = getGalleryImages(trigger);

    if (!state.items.length) {
      const src = trigger.getAttribute('data-image');

      if (!src) return;

      state.items = [{
        element: trigger,
        src: src,
        id: src,
        alt: 'Product image'
      }];
    }

    state.index = state.items.findIndex(
      (item) => item.element === trigger
    );

    if (state.index === -1) {
      const clickedSrc = trigger.getAttribute('data-image');

      state.index = state.items.findIndex(
        (item) => item.src === clickedSrc
      );
    }

    if (state.index === -1) {
      state.index = 0;
    }

    state.previousFocus = document.activeElement;

    state.bodyOverflow = document.body.style.overflow;
    state.htmlOverflow =
      document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    state.isOpen = true;

    state.root.classList.add('is-open');
    state.root.setAttribute('aria-hidden', 'false');

    renderImage();

    state.root.querySelector(
      '[data-rl-action="close"]'
    ).focus({ preventScroll: true });
  }

  function renderImage() {
    if (!state.isOpen || !state.items.length) return;

    const item = state.items[state.index];

    state.image.alt = item.alt;
    state.image.src = item.src;

    state.counter.textContent =
      `${state.index + 1} / ${state.items.length}`;

    const hasMultipleImages = state.items.length > 1;

    state.previousButton.hidden = !hasMultipleImages;
    state.nextButton.hidden = !hasMultipleImages;
  }

  function changeImage(direction) {
    if (!state.isOpen || state.items.length < 2) return;

    state.index =
      (state.index + direction + state.items.length) %
      state.items.length;

    renderImage();
  }

  function closeLightbox() {
    if (!state.isOpen) return;

    state.isOpen = false;

    state.root.classList.remove('is-open');
    state.root.setAttribute('aria-hidden', 'true');

    state.image.removeAttribute('src');

    document.body.style.overflow = state.bodyOverflow;
    document.documentElement.style.overflow =
      state.htmlOverflow;

    if (
      state.previousFocus &&
      typeof state.previousFocus.focus === 'function'
    ) {
      state.previousFocus.focus({ preventScroll: true });
    }

    state.items = [];
  }

  function handleKeyboard(event) {
    if (!state.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeLightbox();
      return;
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      changeImage(-1);
      return;
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      changeImage(1);
      return;
    }

    if (event.key === 'Tab') {
      const buttons = Array.from(
        state.root.querySelectorAll('button:not([hidden])')
      );

      if (!buttons.length) return;

      const first = buttons[0];
      const last = buttons[buttons.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  class ProductImageZoom extends HTMLElement {
    connectedCallback() {
      if (this._rlZoomInitialized) return;

      this._rlZoomInitialized = true;

      this.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        openLightbox(this);
      });
    }
  }

  customElements.define(
    'product-image-zoom',
    ProductImageZoom
  );
})();
